export default class WatchOurDemos {
  constructor() {
    const $els = document.querySelectorAll('.js-watch-our-demos');
    $els.forEach(($el) => new Demo($el));
  }
}

class Demo {
  constructor($el) {
    this.$el = $el;
    this.$buttons = this.$el.querySelectorAll('.js-watch-our-demos-button');
    this.$panels = this.$el.querySelectorAll('.js-watch-our-demos-panel');
    this.$iframes = this.$el.querySelectorAll('iframe');

    this.$buttons.forEach(($button, index) => {
      $button.addEventListener('click', (e) => this.handleClick(e, index));
    });
  }

  stopVideos() {
    this.$iframes.forEach(($iframe) => {
      $iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
    })
  }

  handleClick(e, index) {
    e.preventDefault();

    this.stopVideos();

    this.$panels.forEach($panel => $panel.classList.remove('is-active'));
    this.$buttons.forEach($button => $button.classList.remove('is-active'));

    this.$panels[index]?.classList.add('is-active');
    this.$buttons[index]?.classList.add('is-active');

    if (window.innerWidth < 1024) {
      this.$buttons[index]?.scrollIntoView({
        behavior: 'smooth',
      });
    }
  }
}
